import { Injectable, TemplateRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: unknown[] = [];

  private readonly changed$ = new Subject<void>();

  /**
   * Emits whenever the queue is added to or drained.
   *
   * `toasts` is a plain array this service mutates, so a renderer that lives
   * under an OnPush component is never told a toast arrived — nothing marks that
   * view dirty, and the toast only appears when some unrelated interaction
   * happens to run change detection over that branch. Renderers in that position
   * can subscribe to this and `markForCheck()`. Existing default-CD renderers
   * keep working unchanged; this is additive.
   */
  get changes(): Observable<void> {
    return this.changed$.asObservable();
  }

  show(
    textOrTpl: string | TemplateRef<unknown>,
    options: Record<string, unknown> = {}
  ) {
    this.toasts.push({ textOrTpl, ...options });
    this.changed$.next();
  }

  remove(toast: unknown) {
    this.toasts = this.toasts.filter((t) => t !== toast);
    this.changed$.next();
  }
}
